// (00) 0000-0000
const mask = ['(', /[1-9]/, /[1-9]/, ')', ' ', /[1-8]/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

export default {
    mask: mask,
    guide: false,
    keepCharPositions: true,
    placeholderChar: '\u2000',
};
